export default __webpack_public_path__ + "static/media/background_left.9e7a33fd.png";